import DashboardHeader from '../../../components/DashboardComponents/DashboardHeader/DashboardHeader';
import './Subscription.scss';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { Link } from 'react-router-dom';
import { getAllPackages } from '../../../redux/slices/PackageSlice';
import ShowPaymentPageHOC from '../../../components/CommonComponents/PaymentPage/hoc/ShowPaymentPageHOC';
import Loader from '../../../components/CommonComponents/Loader/Loader';
import ConfirmationPopup from '../../../utils/ConfirmationPopup/ConfirmationPopup';
import QRCodePopup from './QRCodePopup/QRCodePopup';
import { useSubscription } from '../../../utils/CustomHooks/Subscription';
import { FaCheckCircle } from 'react-icons/fa';
import { showToastMessage, ToastType } from '../../../utils/ToastOptionCommon';
const apiUrl = process.env.REACT_APP_API_URL;

interface IPorps {
  submitPackage: () => void;
  showPaymentPopup: boolean;
  showPaymentHandler: () => void;
}

const Subscription = (props: IPorps) => {
  const packages = useSelector((state: any) => state.packages);
  const dispatch = useDispatch<AppDispatch>();
  const [pkgId, setPkgId] = useState('');
  const [amount, setAmount] = useState(1);
  const [desc, setDesc] = useState('');
  const [isAlreadySubscribed, setIsAlreadySubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { freeTrialDays, leftDays } = useSubscription();
  const [billingCycle, setBillingCycle] = useState<'monthly' | 'yearly'>(
    'monthly'
  );
  const [selectedPackage, setSelectedPackage] = useState<any>(null);

  useEffect(() => {
    dispatch(getAllPackages({}));
    if (packages.data?.plan?.isActive) {
      setIsAlreadySubscribed(true);
    }
  }, []);

  const clickHandler = (pkg: any) => {
    setSelectedPackage(pkg);

    const price =
      billingCycle === 'yearly'
        ? pkg.yearlyPrice
        : (pkg.monthlyPrice ?? pkg.price);

    setAmount(price);
    setPkgId(pkg._id);

    props.showPaymentHandler();
  };

  const handleConfirmation = () => {
    console.log(billingCycle);
    createOrder(pkgId, billingCycle);
  };

  const createOrder = async (id: string, cycle: 'monthly' | 'yearly') => {
    try {
      setIsLoading(true);

      const token = localStorage.getItem('accessToken');

      const response = await fetch(`${apiUrl}/payment/phonepe/createOrder`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          planId: id,
          billingCycle: cycle,
          orderId: 1,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));

        throw new Error(
          errorData.message ||
            `Payment request failed with status ${response.status}`
        );
      }

      const order = await response.json();

      if (order?.url) {
        window.location.href = order.url;
      } else {
        throw new Error('Payment URL not received from server');
      }

      return order.id;
    } catch (error) {
      console.error('PhonePe Payment Error:', error);

      showToastMessage(
        'Error initiating payment. Please try again.',
        ToastType.Error
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {props.showPaymentPopup && (
        // <PaymentPopup showMe={props.showPaymentHandler} pkgId={pkgId} />
        // <RazorpayGateway pkgId={pkgId} description={desc} closeModal={props.showPaymentHandler} />
        <ConfirmationPopup
          onModalClose={props.showPaymentHandler}
          onSubmit={handleConfirmation}
          confirmationText="Buying or Upgrading your package will take effect immediately.
        Please note that cancellations or refunds aren't available once the package purchase is complete."
          saveButtonText={'Confirm Upgrade'}
          cancelButtonText={'Go Back'}
          modalTitle={'Package Upgrade Confirmation'}
          isProgress={isLoading}
        />
        // <QRCodePopup
        //   onClose={props.showPaymentHandler}
        //   amount={amount}
        //   name="Preeti Rai"
        //   upiId="preettyrai54@okaxis"
        // />
      )}

      {packages.isLoading && <Loader isSmallLoader={false} />}
      <div className="main-content">
        <DashboardHeader />
        <div className="below-header">
          <div className="row align-items-end">
            <div className="col-sm-6">
              <h1>Package</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Package
                  </li>
                </ol>
              </nav>
            </div>
            {!packages.isLoading && packages.data?.plan?.isActive && (
              <div className="col-sm-6 d-flex align-items-center justify-content-sm-end mt-2 mt-sm-0">
                {packages.data?.plan?.leftDays && (
                  <div className="expire-badge d-inline-flex align-items-center gap-2 px-3 py-1.5 rounded-pill bg-warning-subtle text-warning-emphasis border border-warning-subtle">
                    <span className="pulse-dot"></span>
                    <span className="fw-semibold text-xs">
                      Expires in{' '}
                      <strong>
                        {freeTrialDays > 0 ? freeTrialDays : leftDays}
                      </strong>{' '}
                      {(freeTrialDays > 0 ? freeTrialDays : leftDays) === 1
                        ? 'Day'
                        : 'Days'}
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="subscription">
          {/* Billing Toggle */}
          <div className="billing-toggle-wrapper">
            <div className="billing-toggle">
              <button
                type="button"
                className={billingCycle === 'monthly' ? 'active' : ''}
                onClick={() => setBillingCycle('monthly')}
              >
                Monthly
              </button>

              <button
                type="button"
                className={billingCycle === 'yearly' ? 'active' : ''}
                onClick={() => setBillingCycle('yearly')}
              >
                Yearly
                <span className="save-badge">Save 2 months</span>
              </button>
            </div>
          </div>

          <div className="row g-4 justify-content-center">
            {!packages.isLoading &&
              packages?.data?.packages?.map((e: any, index: number) => {
                const isFree = index === 0;

                const monthlyPrice = e.monthlyPrice ?? e.price;

                const yearlyPrice =
                  e.yearlyPrice ?? Math.round(monthlyPrice * 10);

                const displayPrice = isFree
                  ? 0
                  : billingCycle === 'yearly'
                    ? yearlyPrice
                    : monthlyPrice;

                const validity = isFree
                  ? e.items?.days
                  : billingCycle === 'yearly'
                    ? 365
                    : 30;

                const isCurrentPlan =
                  !!packages.data?.plan?.isActive &&
                  packages.data?.plan?.id === e._id &&
                  (!packages.data?.plan?.billingCycle ||
                    packages.data?.plan?.billingCycle === billingCycle);

                const isRecommended = e.order === 3;

                return (
                  <div key={e._id} className="col-12 col-sm-6 col-lg-3">
                    <div
                      className={`subscription-card ${
                        e.order === 1
                          ? 'free-color'
                          : e.order === 2
                            ? 'basic-color'
                            : e.order === 3
                              ? 'standard-color'
                              : 'premium-color'
                      } ${isRecommended ? 'recommended' : ''}`}
                    >
                      {isRecommended && (
                        <div className="popular-badge">MOST POPULAR</div>
                      )}

                      <div className="plan-top">
                        <h4 className="plan-name">{e.name}</h4>

                        <p className="plan-description">
                          {e.order === 1
                            ? 'Get started with the basics'
                            : e.order === 2
                              ? 'Perfect for individual owners'
                              : e.order === 3
                                ? 'Best value for active owners'
                                : 'For owners with multiple properties'}
                        </p>
                      </div>

                      <div className="plan-price-wrapper">
                        <span className="currency">₹</span>

                        <span className="plan-price">{displayPrice}</span>

                        {!isFree && (
                          <span className="price-period">
                            /{billingCycle === 'yearly' ? 'year' : 'month'}
                          </span>
                        )}
                      </div>

                      {!isFree && billingCycle === 'yearly' && (
                        <div className="monthly-equivalent">
                          Just ₹{Math.round(monthlyPrice)}
                          /month
                        </div>
                      )}

                      <div className="plan-validity">
                        {validity} Days Validity
                      </div>

                      <ul className="plan-features">
                        <li>
                          <FaCheckCircle />
                          {e.items?.propertyListing} Rent/Sell Property Listings
                        </li>

                        <li>
                          <FaCheckCircle />
                          {e.items?.photos} Photos per Property/Room
                        </li>

                        {e.items?.featureProperty ? (
                          <li>
                            <FaCheckCircle />
                            {e.items?.featurePropertyNumber} Featured Properties
                          </li>
                        ) : (
                          <li className="disabled-feature">
                            Feature Properties
                          </li>
                        )}

                        {e.items?.chat ? (
                          <li>
                            <FaCheckCircle />
                            Chat with Tenant
                          </li>
                        ) : (
                          <li className="disabled-feature">Chat with Tenant</li>
                        )}

                        {e.items?.youtubeVideo ? (
                          <li>
                            <FaCheckCircle />
                            YouTube Video Link
                          </li>
                        ) : (
                          <li className="disabled-feature">
                            YouTube Video Link
                          </li>
                        )}

                        {e.items?.support ? (
                          <li>
                            <FaCheckCircle />
                            Customer Support
                          </li>
                        ) : (
                          <li className="disabled-feature">Customer Support</li>
                        )}
                      </ul>

                      <div className="plan-action">
                        {isCurrentPlan ? (
                          <div className="subscribed-plan">
                            <FaCheckCircle />
                            Subscribed
                          </div>
                        ) : (
                          !isFree && (
                            <button
                              type="button"
                              onClick={() => clickHandler(e)}
                              className={`btn btn-primary plan-button ${
                                isRecommended ? 'recommended-button' : ''
                              }`}
                            >
                              {packages.data?.plan?.isActive
                                ? 'Upgrade Now'
                                : 'Get Started'}
                            </button>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowPaymentPageHOC(Subscription);
